import dayjs from '@/libs/util.date.js'
export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    fixed: 'left',
    slots: { default: 'opt' },
  },
  {
    title: '机构账号编码',
    field: 'accountCode',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '开发者账号',
    field: 'appId',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '对接应用授权KEY',
    field: 'appkey',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '对接应用授权加密字符',
    field: 'appSecret',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '授权到期时间',
    field: 'expiresIn',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => {
      if (!cellValue) return ''
      return dayjs(cellValue).format('YYYY-MM-DD')
    },
  },
  {
    title: '三方服务器地址',
    field: 'tpAppHost',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '三方应用授权KEY',
    field: 'tpAppkey',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'tpAppSecret',
    title: '三方应用授权加密字符',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '备注',
    field: 'remark',
    headerAlign: 'center',
    align: 'left',
    width: 300,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'appStatus',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: '应用状态',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'appStatus' },
  },
  {
    title: '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
